module.exports = __webpack_public_path__ + "img/GAME_GETTHENUMBERDISH.ed10b83d.jpg";